module.exports = __webpack_public_path__ + "static/media/JH.fdf4ffc4.png";